import script from "./ManageOrganisationBox.vue?vue&type=script&setup=true&lang=js"
export * from "./ManageOrganisationBox.vue?vue&type=script&setup=true&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
import "./ManageOrganisationBox.vue?vue&type=style&index=1&id=21340833&scoped=true&lang=css"

import exportComponent from "C:\\Users\\jhunr\\Documents\\Work\\GCM3\\repos\\talentsage2026_previous\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21340833"]])

export default __exports__